export enum HTTPMethod {
  GET = "GET",
  POST = "POST",
  DELETE = "DELETE",
  PUT = "PUT",
}

export interface IRequest {
  path: string;
  method: HTTPMethod;
  params?: any;
  data?: any;
}

export interface IResponse {
  [key: string]: any;
}

export interface IError {
  message: string;
  status: number;
  raw: Error;
}
